import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function DeathDismemberment({ classes, expanded, deathDismemberment, handleChange, isStudent }) {    
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('deathDismemberment')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('deathDismemberment') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Accidental Death & Dismemberment</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        deathDismemberment.isEligible !== 1 ? 
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                        You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    }

                    <Text small bold customStyle={{ flex: 1, marginTop: 10 }}>
                        {
                            deathDismemberment.isFlatAmount === 1 ?
                                `\nYou have $${ helpers.formatNumber(deathDismemberment.flatAmount) } of coverage.`
                                : `\nYou have ${ deathDismemberment.timesEarnings }x your annual salary of coverage.`
                        }
                    </Text>

                    <Text small margin="5px 0px 0px 0px">
                        { deathDismemberment.maxEvidence > 0 ? `$${ helpers.formatNumber(deathDismemberment.maxEvidence) } Maximum with evidence of insurability.` : null }
                    </Text>

                    <Text small margin="5px 0px 0px 0px">
                        { deathDismemberment.maxNoEvidence > 0 ? `$${ helpers.formatNumber(deathDismemberment.maxNoEvidence) } Maximum with non-evidence of insurability.` : null }
                    </Text>

                    <Text small margin="5px 0px 0px 0px">
                        { deathDismemberment.minVolume > 0 ? `$${ helpers.formatNumber(deathDismemberment.minVolume) } Minimum.` : null }
                    </Text>

                    { 
                        isStudent ?
                            <Text small margin="5px 0px 0px 0px">
                                { `Terminates at age ${ deathDismemberment.terminationAge } or date of participants study if earlier.` }
                            </Text>
                            :
                            <Text small margin="5px 0px 0px 0px">
                                { `Terminates at age ${ deathDismemberment.terminationAge } or date of participants retirement if earlier.` }
                            </Text>
                    }

                    { 
                        isStudent ?
                            <Text small margin="10px 0px 10px 0px">
                                { `Coverage reduces by ${ deathDismemberment.reducesBy }% at age ${ deathDismemberment.reducesAtAge }, provided the member is still actively studying.` }
                            </Text>
                            :
                            <Text small margin="10px 0px 10px 0px">
                                { `Coverage reduces by ${ deathDismemberment.reducesBy }% at age ${ deathDismemberment.reducesAtAge }, provided the member is still actively working.` }
                            </Text>
                    }

                    { Boolean(deathDismemberment.includeSecondReduction) && 
                                <Text small margin="5px 0px 10px 0px">
                                    {
                                        `Coverage further reduces by ${ deathDismemberment.furtherReducesBy }% at age ${ deathDismemberment.furtherReductionAge }.`
                                    }
                                </Text>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}